import { useState, useEffect } from 'react'

interface useMediaProps {
  queries: string[]
  values: any[]
  defaultValue: any
}
function useMedia({ queries, values, defaultValue }: useMediaProps) {
  // array containing a media query list for each query
  const mediaQueryLists =
    typeof window !== 'undefined' ? queries.map(q => window.matchMedia(q)) : []

  // function that gets value based on matching media query
  const getValue = () => {
    if (typeof window !== 'undefined' && window.matchMedia) {
      // get index of first media query that matches
      const index = mediaQueryLists.findIndex(mql => mql.matches)

      // return related value or defaultValue if none
      return typeof values[index] !== 'undefined' ? values[index] : defaultValue
    } else return defaultValue
  }

  const [value, setValue] = useState(getValue)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // event listener
      const handler = () => setValue(getValue)

      // set a listener for each media query with above handler as a callback
      // mediaQueryLists.forEach((mql) => addEventListener(mql, handler))
      window.addEventListener('resize', handler)

      // remove listeners on cleanup
      return () =>
        // mediaQueryLists.forEach((mql) => mql.removeEventListener(handler))
        window.removeEventListener('resize', handler)
    }
  }, [])

  return value
}

export default useMedia
